import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/TreasureChest.es.js";
const r = e.forwardRef((o, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...o, weights: a }));
r.displayName = "TreasureChestIcon";
const n = r;
export {
  n as TreasureChest,
  r as TreasureChestIcon
};
